<template>
    <div class="page" id="ProVideoLessonSettings">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Video Lesson Settings</h2>
                <ul class="links">
                    <li>
                        <a
                            class="cancel"
                            @click.prevent="goToLocation({ name: 'proLessonDiary' })"
                            href="#"
                        >
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <span class="info mb10">
                Here you can activate or deactivate this feature and set the amount you would like
                to charge for a video lesson
            </span>

            <form class="form3" @submit.prevent="updateSettings">
                <div class="formGroup" id="video-lesson-toggle">
                    <button
                        @click.prevent=""
                        class="button toggle-label"
                        :class="{ dark: enabled, red: !enabled }"
                        type="button"
                        name="button"
                    >
                        <template v-if="enabled"> Video lessons enabled </template>
                        <template v-else> Video lessons disabled </template>
                    </button>
                    <button
                        v-show="!enabled"
                        @click.prevent="enableVideoLesson"
                        class="button dark toggle-button"
                        type="button"
                        name="button"
                    >
                        Enable
                    </button>
                    <button
                        v-show="enabled"
                        @click.prevent="disableVideoLesson"
                        class="button red toggle-button"
                        type="button"
                        name="button"
                    >
                        Disable
                    </button>
                </div>

                <div class="formGroup" v-show="enabled">
                    <span class="select">
                        <currency-input
                            :class="{ selected: form.lesson_price }"
                            ref="price"
                            :value-as-integer="true"
                            class="currencyInput"
                            maxlength="6"
                            v-model="form.video_lessons_price"
                            :currency="$store.state.user.currency"
                            placeholder="Add price of 1 video lesson, e.g. 19.99"
                            style="background: white"
                        />
                    </span>
                </div>

                <div class="formGroup">
                    <button :disabled="form.busy" class="button" type="submit" name="button">
                        {{ form.busy ? "Please wait..." : "Save settings" }}
                    </button>
                </div>
            </form>

            <empty-placeholder class="mt30 mb10 warning" v-if="!enabled">
                IMPORTANT: This area is currently hidden and not available to your Players. To
                activate this feature use the enable button above.
            </empty-placeholder>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
import { Form } from "vform";

export default {
    name: "manage-diary",
    components: {
        EmptyPlaceholder,
        XIcon,
        FadeImage,
    },
    data() {
        return {
            form: new Form({
                lesson_duration: "",
                lesson_price: 0,
                preffered_lesson_duration: 15,
                video_lessons_enabled: false,
                video_lessons_price: null,
            }),
        };
    },
    created() {
        this.getSettings();
    },
    computed: {
        enabled() {
            return this.form.video_lessons_enabled;
        },
    },
    methods: {
        enableVideoLesson() {
            this.form.video_lessons_enabled = true;
        },
        disableVideoLesson() {
            this.form.video_lessons_enabled = false;
        },
        goToLocation($url) {
            if (this.$route.query.from) {
                this.$router.go(-1);
            } else {
                this.$router.push($url);
            }
        },
        getSettings() {
            this.form.get("/settings").then((response) => {
                if (response.data) {
                    this.form.fill(response.data);
                }
            });
        },
        updateSettings() {
            if (this.form.video_lessons_enabled && !this.form.video_lessons_price) {
                this.$notify({
                    type: "error",
                    text: "Please specify a price",
                });
                return;
            }

            this.form.post("/settings").then(() => {
                this.$notify({
                    text: "Your video lesson settings have been updated",
                });
            });
        },
    },
};
</script>

<style lang="scss">
#ProVideoLessonSettings {
    .formGroup {
        margin-bottom: 10px;
    }
    #video-lesson-toggle {
        display: flex;
        button {
            display: inline-block;
            width: auto;

            &.toggle-label {
                flex: 1;
                z-index: 10;
            }

            &.toggle-button {
                z-index: 9;
                padding-left: 40px;
                margin-left: -20px;
            }
        }
    }
}
</style>
